
  document.addEventListener("DOMContentLoaded", function () {
    const lazyVideos = document.querySelectorAll(".lazy-video");

    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            const sources = video.querySelectorAll("source");

            sources.forEach(source => {
              if (source.dataset.src && !source.src) {
                source.src = source.dataset.src;
              }
            });

            // Load the video and start playing if autoplay is set
            video.load();

            // Optionally wait for load before playing
            if (video.hasAttribute("autoplay")) {
              video.play().catch(() => {
                // Handle play errors (e.g. user interaction required)
              });
            }

            observer.unobserve(video);
          }
        });
      }, {
        threshold: 0.25 // Customize how much needs to be visible
      });

      lazyVideos.forEach(video => {
        videoObserver.observe(video);
      });
    } else {
      // Fallback: Load all videos immediately
      lazyVideos.forEach(video => {
        const sources = video.querySelectorAll("source");
        sources.forEach(source => {
          if (source.dataset.src && !source.src) {
            source.src = source.dataset.src;
          }
        });
        video.load();
        if (video.hasAttribute("autoplay")) {
          video.play().catch(() => {});
        }
      });
    }
  });

